/**
 * @generated SignedSource<<6f5e005455dab7cd4a6092fd34823abe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TemplateSelectorUpdateTemplatePopupMutation$variables = {
  name?: string | null;
  templateId: string;
  todoWorkspaceId: string;
};
export type TemplateSelectorUpdateTemplatePopupMutation$data = {
  readonly todoWorkspaceTemplate: {
    readonly updateTemplateFromWorkspaceTodo: {
      readonly id: string;
      readonly name: string;
    };
  };
};
export type TemplateSelectorUpdateTemplatePopupMutation = {
  response: TemplateSelectorUpdateTemplatePopupMutation$data;
  variables: TemplateSelectorUpdateTemplatePopupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoWorkspaceId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "templateId"
      }
    ],
    "concreteType": "TodoWorkspaceTemplateMutation",
    "kind": "LinkedField",
    "name": "todoWorkspaceTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "todoWorkspaceId"
          },
          {
            "kind": "Variable",
            "name": "setName",
            "variableName": "name"
          }
        ],
        "concreteType": "TodoWorkspaceTemplate",
        "kind": "LinkedField",
        "name": "updateTemplateFromWorkspaceTodo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TemplateSelectorUpdateTemplatePopupMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TemplateSelectorUpdateTemplatePopupMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "30af0251dd199da2095d1ba90a4f7ebc",
    "id": null,
    "metadata": {},
    "name": "TemplateSelectorUpdateTemplatePopupMutation",
    "operationKind": "mutation",
    "text": "mutation TemplateSelectorUpdateTemplatePopupMutation(\n  $templateId: ID!\n  $todoWorkspaceId: ID!\n  $name: String\n) {\n  todoWorkspaceTemplate(id: $templateId) {\n    updateTemplateFromWorkspaceTodo(id: $todoWorkspaceId, setName: $name) {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6d70d462f0c9465a75d574bdae1eb2a0";

export default node;
